import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'radix-ui';
import { useState } from 'react';
import { InfoColumn } from './InfoColumn';
import { AudioManager } from '@game-libs/audio-manager';
import { MenuEvents } from '@game-libs/models';

export const StatsAndInfoList = () => {
  const [infoOpen, setInfoOpen] = useState(true);
  const [selectedTab, setSelectedTab] = useState<string>('stats');
  const { t } = useTranslation('infos');
  const { playSFX } = AudioManager();

  const tabs = ['stats' /*'events'*/] as const;

  return (
    <div id="stats-and-info-list-container" className={`${styles.upgradesList} ${infoOpen ? styles.upgradesOpen : ''}`}>
      <div className={`${styles.itemsBanner}`}>
        {t(`banner.${selectedTab}`)}
      </div>
      <Tabs.Root
        className={styles.tabsRoot}
        onClick={() => setInfoOpen(true)}
        onValueChange={(value) => {
          if (value) {
            setSelectedTab(value);
            playSFX(MenuEvents.CHANGE_VALUE);
          }
        }}
        value={selectedTab}
        orientation="vertical"
      >
        <Tabs.List className={styles.tabsButtons} aria-label="info tabs">
          {/* {tabs.map((tab) => (
            <Tabs.Trigger asChild key={tab} className="radix-tabs-trigger" value={tab}>
              <div>{t(`tabs.${tab}`)}</div>
            </Tabs.Trigger>
          ))} */}
        </Tabs.List>
        <div className={styles.upgradesFrame}>
          {tabs.map((tab) => (
            <Tabs.Content key={tab} value={tab}>
              <InfoColumn tab={tab} />
            </Tabs.Content>
          ))}
        </div>
      </Tabs.Root>
    </div>
  );
};
